import React from "react";
import ReactECharts from "echarts-for-react";
import { useQuery } from "@tanstack/react-query";
import { adminURL } from "../../utils/urls";

const fetchActiveUsertData = async () => {
  const { data } = await adminURL.get(`charts/active-users`);
  return data;
};

const DailyActiveUserChart = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["active-user"],
    queryFn: fetchActiveUsertData,
  });

  if (isLoading) return <p>Loading...</p>;
  if (error) return <p>Error loading data</p>;

  const date = data ? data.labels : [];
  const users = data ? data.series[0].data : [];

  const options = {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "line",
        lineStyle: {
          type: "dashed",
          color: "rgba(224, 224, 224, 0.2)",
        },
        crossStyle: {
          type: "dashed",
          color: "rgba(224, 224, 224, 0.2)",
        },
      },
      backgroundColor: "rgba(0, 0, 0, 0.7)",
      borderWidth: "1px",
      textStyle: {
        color: "#fff",
      },
    },
    legend: {
      show: false,
    },
    xAxis: {
      type: "category",
      data: date,
    },
    yAxis: {
      type: "value",
      splitLine: {
        lineStyle: {
          color: "#e0e0e0",
          opacity: "0.2",
        },
      },
      axisLabel: {
        formatter: function (value) {
          return Math.floor(value / 100) * 100;
        },
      },
    },
    series: [
      {
        name: "Number of Users",
        type: "line",
        smooth: false,
        data: users,
        showSymbol: true,
        symbolSize: 8,
        itemStyle: {
          color: "#ff9800",
        },
        lineStyle: {
          width: 2,
          color: "#ff9800",
        },
      },
    ],
  };

  return (
    <div className="flex flex-col w-full space-y-2 rounded-lg bg-gray-500 bg-opacity-10">
      <h2 className="text-white py-2 px-4 text-lg border-[0.5px] border-customBorderTwo rounded-t-lg">
        Daily Active users
      </h2>
      <div className="p-3">
        {data && (
          <div>
            <ReactECharts
              option={options}
              style={{ height: "400px", width: "100%" }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DailyActiveUserChart;
